import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { endOfYear, startOfYear } from 'date-fns'

import { getRequestTypeName, getUserName } from 'services/Utilities'
import { generateDateText } from 'services/Requests'
import { Format, Parse } from 'services/Dates'
import { createErrorNotification } from 'store/actions/notifications'
import { destroy, init } from 'store/actions/tables'

import { Card, Table } from 'components/UI'
import BaseModal from 'components/Modals/BaseModal'
import Api from 'services/Api'
import { Alert } from 'ui'

import { t } from 'translations'

const EmployeeTimeOffRequestsModal = ({ userId }) => {
  const dispatch = useDispatch()
  const { employeeTimeOffRequests: { count } = {} } = useSelector(state => state.tables)

  useEffect(() => {
    async function fetchUserTimeOff({ filter, page }) {
      const rangeStart = Format(startOfYear(new Date()), { outFormat: 'date' })
      const rangeEnd = Format(endOfYear(new Date()), { outFormat: 'date' })

      const { count, vacations, success } = await Api(`/requests/vacation`, {
        params: { ...filter, limit: 10, page, userId, rangeStart, rangeEnd, sort: '-start' }
      })
      if (!success) return dispatch(createErrorNotification())
      return [vacations, count]
    }
    const header = [
      {
        key: '_id',
        label: 'components.employeeTimeOffRequests.DATES',
        type: 'custom',
        notRemovable: true,
        render: (none, { start, end }) => generateDateText(start, end)
      },
      {
        key: 'vacationTypeId',
        label: 'components.employeeTimeOffRequests.VACATIONTYPE',
        type: 'custom',
        notRemovable: true,
        render: vacationTypeId => getRequestTypeName(vacationTypeId)
      }
    ]

    init('employeeTimeOffRequests', header, fetchUserTimeOff, { defaultSortKey: '-start' })
    return () => destroy('employeeTimeOffRequests')
  }, [dispatch, userId])

  return (
    <BaseModal title={`components.employeeTimeOffRequests`}>
      <Alert variant="info" className="my-3">
        {t(`components.employeeTimeOffRequests.TIME_OFFS_THIS_YEAR`, {
          name: getUserName(userId),
          count: count,
          year: Format(Parse(new Date()), { outFormat: 'year' })
        })}
      </Alert>
      <Card>
        <Table name="employeeTimeOffRequests" />
      </Card>
    </BaseModal>
  )
}

export default EmployeeTimeOffRequestsModal
